<div class="admin-subscription">
  <div class="admin-subscription__title">
    Abonnement
  </div>
  <div class="admin-subscription__content">
    <router-outlet></router-outlet>
  </div>
</div>
